// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { FormField, Select } from 'grommet'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { getSupportedLocales } from '../../utils/common-utils'

export const Preferences = ({
  label,
  name,
  placeholder,
  value,
  dispatch = {}
}) => {
  const { t } = useTranslation(['user_personalisation'])
  const options = {
    language: getSupportedLocales(),
    measure: [
      { name: t('general_preferences.measure_unit.feet'), code: 'feet' },
      { name: t('general_preferences.measure_unit.meters'), code: 'meters' }
    ],
    temperature: [
      {
        name: t('general_preferences.temperature_unit.fahrenheit'),
        code: 'fahrenheit'
      },
      {
        name: t('general_preferences.temperature_unit.celsius'),
        code: 'celsius'
      }
    ]
  }
  const handleOnChange = ({ option }) => {
    dispatch({
      value: option.code,
      field: name,
      type: 'CHANGE_FIELD'
    })
  }
  return (
    <FormField
      margin={{ bottom: 'medium' }}
      label={label}
      name={name}
      required
      data-testid={`${name}-form-field`}
    >
      <Select
        name={name}
        placeholder={placeholder}
        options={options[name]}
        multiple={false}
        labelKey="name"
        value={value}
        valueKey={{ key: 'code', reduce: true }}
        onChange={handleOnChange}
      />
    </FormField>
  )
}
Preferences.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  dispatch: PropTypes.object
}
